import React from 'react';

import { locale } from '@trqk/utils';

export const EmptyChartMessage = (): JSX.Element => (
    <div className="text-center text-tertiary-400 italic mt-10">
        {locale.enUS.CHART_HAS_NO_DATA}
    </div>
);
